import { memo } from 'react';
import AiSearchContentTypeDropdown from './AiSearchContentTypeDropdown';
import { DROPDOWN_LABELS } from '../constants';
import { useAiSearchContext } from '../AiSearchContext';
import IconButton from '@/components/atoms/Button/IconButton';
import { classnames } from '@/libs/utils';

function AiSearchToolbar() {
  const {
    selectedPromptOption,
    arePromptOptionsVisible,
    isPromptOptionSelected,
    isRecentSearchesVisible,
    isLoading,
    isSearchButtonDisabled,
    togglePopover,
    selectPromptOption,
    toggleRecentSearches
  } = useAiSearchContext();

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-2">
        {/* Content Type Dropdown */}
        <AiSearchContentTypeDropdown
          selectedOption={selectedPromptOption}
          isVisible={arePromptOptionsVisible}
          isSelected={isPromptOptionSelected}
          options={DROPDOWN_LABELS}
          onToggle={togglePopover}
          onSelect={selectPromptOption}
          disabled={isLoading}
        />

        {/* History Button */}
        <IconButton
          icon="IconHistory"
          size="base"
          variation="text"
          type="button"
          disabled={isLoading}
          trackingId="ai-search-history-button"
          buttonClassName={classnames('size-8 rounded-lg', {
            'hover:bg-slate-100': !isRecentSearchesVisible,
            'bg-black/[0.08] hover:bg-slate-200': isRecentSearchesVisible
          })}
          iconClassName="text-slate-600"
          onClick={toggleRecentSearches}
        />
      </div>

      {/* Start/Search Button */}
      <IconButton
        icon={isLoading ? 'IconLoader2' : 'IconSend'}
        size="base"
        type="submit"
        variation="text"
        trackingId="ai-search-start-button"
        disabled={isSearchButtonDisabled}
        buttonClassName={classnames('size-8 rounded-lg', !isSearchButtonDisabled ? 'bg-slate-900' : 'bg-slate-200', {
          'bg-slate-100': isLoading
        })}
        iconClassName={classnames(isSearchButtonDisabled ? 'text-slate-400' : 'text-white', {
          'animate-spin': isLoading
        })}
      />
    </div>
  );
}

export default memo(AiSearchToolbar);
